import React from "react";

export default function ComingSoon() {
  return (
    <div style={{
      display: "flex", flexDirection: "column", alignItems: "center",
      justifyContent: "center", height: "60vh", gap: "12px",
    }}>
      <div style={{
        width: "48px", height: "48px", borderRadius: "12px",
        backgroundColor: "var(--bg-secondary)", border: "1px solid var(--border)",
        display: "flex", alignItems: "center", justifyContent: "center", fontSize: "22px",
      }}>🚧</div>
      <div style={{ fontSize: "15px", fontWeight: 600, color: "var(--text-primary)" }}>
        Coming Soon
      </div>
      <div style={{ fontSize: "13px", color: "var(--text-secondary)", textAlign: "center", maxWidth: "280px" }}>
        This section is under development and will be available in a future update.
      </div>
    </div>
  );
}
